import React, {useState} from "react";
import {getStudentData} from "../../services/verification";
import "./style.css"
import fialogo from "../../assets/fialogocircley.jpg"
import {toast} from 'react-toastify';


function Verification_Form({setCertificateData, setShowCertificate}){
    const [rollNo, setRollNo] = useState('');
    const handleVerifyClick = () =>{
        getStudentData(rollNo).then(res=>{
            if(res.data && res.data.length) {
                setCertificateData(res.data[0]);
                setShowCertificate(true);
            }
            else  {
                toast.error('Roll no not found');
            }
        }).catch(err=>{
            toast.error('Internal server error');
        })
    };

    const handleResetClick = () => {
        setRollNo('');
        setShowCertificate(false);
    }
    return(
        <div>
            <div className="d-flex justify-content-center">

                <img className="fialogo mb-2"   src={fialogo} alt="FIA logo"/>

            </div>
        <div>
            <h3 className="text-center ">Enter Enrollment Number</h3>
        </div>
        <div className="form-outline d-flex justify-content-center">
            <input type="text" placeholder="Enrollment Number" id="form1" className="form-control enrollment-number my-3" value={rollNo} onChange={(e=>(setRollNo(e.target.value)))} />

        </div>

        <div className="d-flex justify-content-center mb-5 mt-3">
            <button type="button" className="btn btn-verify rounded-pill px-5 fw mr-3 " onClick={handleVerifyClick} disabled={!rollNo}>Verify</button>
            <button type="button" className="btn btn-verify rounded-pill px-5 fw ml-3" onClick={handleResetClick}>Reset</button>

        </div>





</div>



    );


}

export default Verification_Form;
